export enum SystemRole {
  User,
  SystemAdministrator
}
